import { render, staticRenderFns } from "./JdsDropdownMenu.vue?vue&type=template&id=79b2705e&scoped=true&"
import script from "./JdsDropdownMenu.vue?vue&type=script&lang=ts&"
export * from "./JdsDropdownMenu.vue?vue&type=script&lang=ts&"
import style0 from "./JdsDropdownMenu.vue?vue&type=style&index=0&id=79b2705e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b2705e",
  null
  
)

export default component.exports